import { RiTimeLine } from 'react-icons/ri';
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter
} from 'reactstrap';

const SoftwareCreationStartedModal = ({ t, isOpen, toggle }) => (
    <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered
        size="md"
    >
        <ModalBody className="text-center py-5 px-4">
            <div
                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
            >
                <RiTimeLine 
                    size="34"
                    className='text-primary'
                />
            </div>

            <h3 className="fw-semibold mt-4 mb-3">
                {t('Software Creation Started')}
            </h3>

            <p
                className="text-body mb-4 mx-auto font-size-16"
                style={{
                    maxWidth: 440
                }}
            >
                {t('Your request has been accepted and the software creation process has started in the background.')}
            </p>

            <div
                className="mx-auto px-4 py-3 rounded"
                style={{
                    maxWidth: 460
                }}
            >
                <div className="d-flex align-items-start text-start">
                    <i className="ri-notification-3-line text-primary fs-4 me-3 mt-1" />

                    <p
                        className="mb-0 text-muted"
                        style={{
                            fontSize: '.95rem',
                            lineHeight: 1.6
                        }}
                    >
                        {t("You'll receive a notification when the process has completed or if any issues occur can safely continue using the application.")}
                    </p>
                </div>
            </div>

        </ModalBody>

        <ModalFooter className="justify-content-center border-0 pt-0 pb-4">
            <Button
                color="primary"
                className="px-4"
                onClick={toggle}
            >
                {t('Continue')}
            </Button>
        </ModalFooter>
    </Modal>
);

export default SoftwareCreationStartedModal;